import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, TrendingUpIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProductReveal() {
  return <section className="w-full bg-[#0B1C2C] py-20 px-4 sm:px-6 lg:px-8" data-id="element-147">
      <div className="max-w-7xl mx-auto" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-149">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#F2F4F8] mb-6" data-id="element-150">
            Descubre{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2F6BFF] to-[#7EC8FF]" data-id="element-151">
              La Verdad Completa
            </span>
          </h2>
          <p className="text-xl text-[#F2F4F8]/80 max-w-3xl mx-auto" data-id="element-152">
            Un manual completo basado en estudios científicos reales, sin
            conflictos de interés.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-153">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-[#132A44] border border-[#2F6BFF]/20 rounded-xl p-8 text-center" data-id="element-154">
            <div className="w-16 h-16 bg-[#2F6BFF]/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-155">
              <BookOpenIcon className="w-8 h-8 text-[#2F6BFF]" data-id="element-156" />
            </div>
            <h3 className="text-2xl font-bold text-[#F2F4F8] mb-4" data-id="element-157">
              100% Basado en Ciencia
            </h3>
            <p className="text-[#F2F4F8]/70" data-id="element-158">
              Cada afirmación respaldada por estudios científicos publicados.
              Sin opiniones, solo hechos.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-[#132A44] border border-[#2F6BFF]/20 rounded-xl p-8 text-center" data-id="element-159">
            <div className="w-16 h-16 bg-[#2F6BFF]/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-160">
              <TrendingUpIcon className="w-8 h-8 text-[#2F6BFF]" data-id="element-161" />
            </div>
            <h3 className="text-2xl font-bold text-[#F2F4F8] mb-4" data-id="element-162">
              Ahorra Miles De Pesos
            </h3>
            <p className="text-[#F2F4F8]/70" data-id="element-163">
              Aprende a identificar qué creatinas valen la pena y cuáles son
              puro marketing inflado.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-[#132A44] border border-[#2F6BFF]/20 rounded-xl p-8 text-center" data-id="element-164">
            <div className="w-16 h-16 bg-[#2F6BFF]/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-165">
              <ShieldCheckIcon className="w-8 h-8 text-[#2F6BFF]" data-id="element-166" />
            </div>
            <h3 className="text-2xl font-bold text-[#F2F4F8] mb-4" data-id="element-167">
              Sin Conflictos de Interés
            </h3>
            <p className="text-[#F2F4F8]/70" data-id="element-168">
              No estoy patrocinado por ninguna marca. Solo la verdad, sin
              filtros ni agendas ocultas.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center" data-id="element-169">
          <CTAButton size="large" data-id="element-170">Quiero Acceso Ahora →</CTAButton>
        </motion.div>
      </div>
    </section>;
}